import client from "./Client";

const getSessions = (schoolId) =>
  client.get(`/school/${schoolId}/sessions`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

const getSession = (sessionId, schoolId) =>
  client.get(`/school/${schoolId}/sessions/${sessionId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

export default {
  getSession,
  getSessions,
};
